import React from "react";

function splitMonthlyPrice(text) {
    const value = String(text || "");
    if (!value) {
        return { amount: "", suffix: "" };
    }
    const parts = value.split(" / ");
    if (parts.length <= 1) {
        return { amount: value, suffix: "" };
    }
    return {
        amount: parts[0],
        suffix: `Per ${parts.slice(1).join(" / ")}`,
    };
}

function MobilePlanPriceCard({
    classes,
    badgeText,
    title,
    promotionText,
    monthlyPriceText,
    originalPrice,
    currentPrice,
    ctaLabel,
    onChoose,
}) {
    const monthlyPrice = splitMonthlyPrice(monthlyPriceText);

    return (
        <button type="button" className={classes.mobilePlanCard} onClick={onChoose}>
            <span className={classes.mobilePlanSaveBadge}>{badgeText}</span>
            <div className={classes.mobilePlanBody}>
                <div className={classes.mobilePlanInfoRow}>
                    <div className={classes.mobilePlanLeftColumn}>
                        <span className={classes.mobilePlanTitle}>{title}</span>
                        <div className={classes.mobilePlanPriceRow}>
                            <span className={classes.mobilePlanOriginalPrice}>{originalPrice}</span>
                            <span className={classes.mobilePlanCurrentPrice}>{currentPrice}</span>
                        </div>
                    </div>
                    <div className={classes.mobilePlanMonthly}>
                        {!!promotionText && (
                            <span className={classes.mobilePlanPromoText}>{promotionText}</span>
                        )}
                        <span className={classes.mobilePlanAmount}>{monthlyPrice.amount}</span>
                        {!!monthlyPrice.suffix && (
                            <span className={classes.mobilePlanSuffix}>{monthlyPrice.suffix}</span>
                        )}
                    </div>
                </div>
                <span className={classes.mobilePlanCta}>{ctaLabel}</span>
            </div>
        </button>
    );
}

export default MobilePlanPriceCard;
